import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-currencies-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './currencies-page.component.html',
  styleUrl: './currencies-page.component.css'
})
export class CurrenciesPageComponent {

}
